import { LoadingLazyComponents } from 'ict24h-themes-react'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { lazy } from 'react'
import { TASK_FILE_CATEGORY_PREFIX_URL } from './constants/config.task-file-category'

const ListPage = lazy(() => import('./pages/ListPage.TaskFileCategory'))

const TaskFileCategoryRouters: AppRouterItem[] = [
  {
    path: `${TASK_FILE_CATEGORY_PREFIX_URL}/`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPage />
      </LoadingLazyComponents>
    ),
  },
]

export default TaskFileCategoryRouters
